import z from "zod";
import {
  BookingSchema,
  EventSchema,
  LocationSchema,
  OrgSchema,
  TicketSchema,
  TicketTierSchema,
  UserSchema,
} from "../models/generated";

export const CheckInTicketSchema = z.object({
  ticketId: z.string().uuid(),
});
export type CheckInTicket = z.infer<typeof CheckInTicketSchema>;

export const TicketDetailSchema = TicketSchema.extend({
  booking: BookingSchema.extend({
    user: UserSchema,
  }),
  ticketTier: TicketTierSchema.extend({
    event: EventSchema.extend({
      host: OrgSchema,
      location: LocationSchema,
    }),
  }),
});
export type TicketDetail = z.infer<typeof TicketDetailSchema>;
